import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconCircleAroundEdit = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <circle cx="10" cy="10" r="9.5" fill="white" stroke="#158463" />
  </SVG>
)

export default withIconStyles(IconCircleAroundEdit)
